import React from 'react'
import ErrorBoundaryProvider from 'utils/bugsnag'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { Auth0Provider } from '@auth0/auth0-react'
import App from 'components/App'
import { I18nextProvider } from 'react-i18next'
import reportWebVitals from './reportWebVitals'

// i18n settings
import i18n from './i18n'

// Redux
import store from './store'

import 'stylesheets/application.scss'

const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE
const redirectUri = typeof window !== 'undefined' ? `${window.location.origin}/login` : undefined

if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  console.log('[Auth0] domain:', auth0Domain ? `${auth0Domain.substring(0, 20)}...` : '(empty)')
  console.log(
    '[Auth0] clientId:',
    auth0ClientId ? `${auth0ClientId.substring(0, 8)}...` : '(empty)'
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <Provider store={store}>
    <ErrorBoundaryProvider>
      <I18nextProvider i18n={i18n}>
        <Auth0Provider
          domain={auth0Domain || ''}
          clientId={auth0ClientId || ''}
          cacheLocation="localstorage"
          useRefreshTokens
          authorizationParams={{
            audience: auth0Audience || undefined,
            redirect_uri: redirectUri,
            scope: 'openid profile email'
          }}
        >
          <React.StrictMode>
            <App />
          </React.StrictMode>
        </Auth0Provider>
      </I18nextProvider>
    </ErrorBoundaryProvider>
  </Provider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
